(function () {
  'use strict';

  var MARKUP_MAX = 1.5;
  var SK = 'rg_padj7';

  // Cargar _adj desde sessionStorage
  var _adj = { gte: null, lte: null };
  try {
    var _s = sessionStorage.getItem(SK);
    if (_s) _adj = JSON.parse(_s);
  } catch (e) {}

  function _save() {
    try { sessionStorage.setItem(SK, JSON.stringify(_adj)); } catch (e) {}
  }

  // ---- Formatea número con comas: 7500 → "7,500" ----
  function _fmtNum(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ---- Parsea precio desde texto como "$ 1,394" → 1394 ----
  function _parsePrice(text) {
    var clean = text.replace(/[^0-9.]/g, '');
    return parseFloat(clean);
  }

  // ---- Corrige el badge de precio en los chips activos ----
  // Reemplaza el valor modificado (lte.original) por el valor del usuario (lte.display)
  function _fixBadge() {
    if (!_adj.lte || _adj.lte.display === _adj.lte.original) return;
    var origStr = _fmtNum(_adj.lte.original); // ej: "7,500"
    var dispStr = _fmtNum(_adj.lte.display);  // ej: "5,000"
    document.querySelectorAll('facet-remove-component.facets-remove__pill').forEach(function (chip) {
      var node = chip.childNodes[0];
      if (node && node.nodeType === 3 && node.textContent.indexOf(origStr) !== -1) {
        node.textContent = node.textContent.replace(origStr, dispStr);
      }
    });
  }

  // ---- Oculta tarjetas cuyo precio mostrado cae fuera del rango del usuario ----
  function _filterCards() {
    var minVal = _adj.gte ? _adj.gte.display : null;
    var maxVal = _adj.lte ? _adj.lte.display : null;

    document.querySelectorAll('.product-grid__item').forEach(function (li) {
      if (minVal === null && maxVal === null) {
        li.style.display = '';
        return;
      }
      var priceEl = li.querySelector('product-card .price');
      if (!priceEl) return;
      var price = _parsePrice(priceEl.textContent);
      if (isNaN(price)) return;
      var hide = false;
      if (minVal !== null && price < minVal) hide = true;
      if (maxVal !== null && price > maxVal) hide = true;
      li.style.display = hide ? 'none' : '';
    });
    _fixBadge();
  }

  // ---- Polling rápido: 100ms × 3s después de cambio de filtro ----
  var _fastTimer = null;
  var _pollEnd = 0;

  function _startFast() {
    _pollEnd = Date.now() + 3000;
    if (_fastTimer) return;
    _fastTimer = setInterval(function () {
      populateInputs();
      _filterCards();
      if (Date.now() >= _pollEnd) {
        clearInterval(_fastTimer);
        _fastTimer = null;
      }
    }, 100);
  }

  // ---- Polling lento: 500ms persistente mientras hay filtro de precio activo ----
  var _slowTimer = null;

  function _startSlow() {
    if (_slowTimer) return;
    _slowTimer = setInterval(function () {
      if (!_adj.lte && !_adj.gte) {
        clearInterval(_slowTimer);
        _slowTimer = null;
        return;
      }
      populateInputs();
      _filterCards();
    }, 500);
  }

  function _stopSlow() {
    if (_slowTimer) { clearInterval(_slowTimer); _slowTimer = null; }
  }

  // ---- Ajusta params de precio en URL ----
  // gte: se envía tal cual (sin conversión)
  // lte: se multiplica x1.5 para capturar productos con descuento de hasta 33%
  // El filtro preciso lo hace _filterCards() leyendo el precio mostrado en el DOM
  function adjustPriceInUrl(urlStr) {
    try {
      var isAbs = /^https?:\/\//i.test(urlStr);
      var url = new URL(urlStr, isAbs ? undefined : window.location.href);
      var p = url.searchParams;
      var changed = false;

      var gteKeys = ['filter.v.price.gte', 'filter.p.price.gte'];
      var lteKeys = ['filter.v.price.lte', 'filter.p.price.lte'];

      function getFirstParam(keys) {
        for (var i = 0; i < keys.length; i++) {
          var v = p.get(keys[i]);
          if (v !== null) return { key: keys[i], val: parseFloat(v) };
        }
        return null;
      }

      var gteP = getFirstParam(gteKeys);
      var lteP = getFirstParam(lteKeys);

      if (!gteP && !lteP) return urlStr;

      if (gteP && !isNaN(gteP.val) && gteP.val > 0) {
        if (_adj.gte && gteP.val === _adj.gte.original) {
          // ya procesado, no tocar
        } else {
          _adj.gte = { display: gteP.val, original: gteP.val };
          changed = true;
        }
      }

      if (lteP && !isNaN(lteP.val) && lteP.val > 0) {
        if (_adj.lte && lteP.val === _adj.lte.original) {
          // ya es el valor convertido, no tocar
        } else {
          var origLte = Math.round(lteP.val * MARKUP_MAX);
          _adj.lte = { display: lteP.val, original: origLte };
          p.set(lteP.key, origLte);
          changed = true;
        }
      }

      if (changed) _save();
      // Siempre iniciar polling rápido cuando hay params de precio (cubre paginación, etc.)
      _startFast();
      if (!changed) return urlStr;
      return isAbs ? url.toString() : (url.pathname + url.search + url.hash);
    } catch (e) {
      return urlStr;
    }
  }

  // ---- Restaura valores de display en los inputs ----
  function populateInputs() {
    var p = new URLSearchParams(window.location.search);

    var hasGte = ['filter.v.price.gte', 'filter.p.price.gte'].some(function (k) { return p.has(k); });
    var hasLte = ['filter.v.price.lte', 'filter.p.price.lte'].some(function (k) { return p.has(k); });
    if (!hasGte && !hasLte) {
      _adj = { gte: null, lte: null };
      _save();
      _stopSlow();
      return;
    }

    function applyDisplay(keys, adjEntry) {
      if (!adjEntry) return;
      var found = false;
      for (var i = 0; i < keys.length; i++) {
        var paramVal = parseFloat(p.get(keys[i]));
        if (paramVal === adjEntry.original || paramVal === adjEntry.display) { found = true; break; }
      }
      if (!found) return;
      var selector = keys.map(function (k) { return 'input[name="' + k + '"]'; }).join(', ');
      document.querySelectorAll(selector).forEach(function (el) {
        el.value = adjEntry.display;
      });
    }

    applyDisplay(['filter.v.price.gte', 'filter.p.price.gte'], _adj.gte);
    applyDisplay(['filter.v.price.lte', 'filter.p.price.lte'], _adj.lte);
    _startSlow();
  }

  // ---- INTERCEPTAR history.pushState ----
  var _origPS = history.pushState.bind(history);
  history.pushState = function (state, title, url) {
    if (url) {
      var adj = adjustPriceInUrl(String(url));
      return _origPS(state, title, adj);
    }
    return _origPS(state, title, url);
  };

  // ---- INTERCEPTAR window.fetch ----
  var _origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string') {
        input = adjustPriceInUrl(input);
      } else if (input && typeof input.url === 'string') {
        var adjUrl = adjustPriceInUrl(input.url);
        if (adjUrl !== input.url) input = new Request(adjUrl, input);
      }
    } catch (e) {}
    return _origFetch(input, init);
  };

  // ---- Atrás/adelante en historial ----
  window.addEventListener('popstate', function () {
    requestAnimationFrame(function () {
      setTimeout(function () {
        populateInputs();
        _filterCards();
      }, 100);
    });
  });

  // ---- INIT ----
  function initWithDelay() {
    populateInputs();
    _filterCards();
    requestAnimationFrame(function () {
      setTimeout(function () {
        populateInputs();
        _filterCards();
      }, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWithDelay);
  } else {
    initWithDelay();
  }

  document.addEventListener('page:load', initWithDelay);
  document.addEventListener('turbo:render', initWithDelay);
  document.addEventListener('shopify:section:load', function () {
    populateInputs();
    _filterCards();
  });

})();
